// Match emoji-presentation characters and qualified sequences while preserving punctuation and text symbols.
const emojiPattern =
  /(?:\p{Regional_Indicator}{2}|[#*0-9]\uFE0F?\u20E3|(?:\p{Emoji_Presentation}|\p{Extended_Pictographic}\uFE0F)\uFE0F?(?:\p{Emoji_Modifier})?(?:\u200D(?:\p{Emoji_Presentation}|\p{Extended_Pictographic}\uFE0F)\uFE0F?(?:\p{Emoji_Modifier})?)*)/gu;

export function stripEmojis(text: string): string {
  return text.replace(emojiPattern, "");
}
